export default __webpack_public_path__ + "static/media/DR.73951ac7.jpeg";